import React from 'react';
import { Paperclip, Download, FileText } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Inline preview for images/PDFs/audio/video; falls back to a download chip
 * for everything else (docx/xlsx). */
const AttachmentPreview = ({ attachment, dark }) => {
  const url = `${BACKEND_URL}${attachment.url}`;
  const previewUrl = `${url}?disposition=inline`;
  const contentType = attachment.content_type || '';

  if (contentType.startsWith('image/')) {
    return (
      <a href={url} target="_blank" rel="noreferrer" data-testid={`lead-attachment-${attachment.id}`} className="block">
        <img
          src={previewUrl}
          alt={attachment.filename}
          className="max-w-[220px] max-h-[220px] rounded-lg border border-white/20 object-cover"
        />
        <span className={`text-xs mt-1 flex items-center gap-1 ${dark ? 'text-slate-300' : 'text-slate-500'}`}>
          <Download className="w-3 h-3" /> {attachment.filename}
        </span>
      </a>
    );
  }

  if (contentType === 'application/pdf') {
    return (
      <a href={url} target="_blank" rel="noreferrer" data-testid={`lead-attachment-${attachment.id}`} className="block">
        <iframe
          src={previewUrl}
          title={attachment.filename}
          className="w-56 h-64 rounded-lg border border-white/20 bg-white pointer-events-none"
        />
        <span className={`text-xs mt-1 flex items-center gap-1 ${dark ? 'text-slate-300' : 'text-slate-500'}`}>
          <FileText className="w-3 h-3" /> {attachment.filename}
        </span>
      </a>
    );
  }

  if (contentType.startsWith('audio/')) {
    return (
      <div data-testid={`lead-attachment-${attachment.id}`}>
        <audio controls src={previewUrl} className="max-w-[260px]" />
        <span className={`text-xs mt-1 block ${dark ? 'text-slate-300' : 'text-slate-500'}`}>{attachment.filename}</span>
      </div>
    );
  }

  if (contentType.startsWith('video/')) {
    return (
      <div data-testid={`lead-attachment-${attachment.id}`}>
        <video controls src={previewUrl} className="max-w-[260px] rounded-lg border border-white/20" />
        <span className={`text-xs mt-1 block ${dark ? 'text-slate-300' : 'text-slate-500'}`}>{attachment.filename}</span>
      </div>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid={`lead-attachment-${attachment.id}`}
      className={`inline-flex items-center gap-1.5 text-xs px-2 py-1 rounded-full ${
        dark ? 'bg-white/10 hover:bg-white/20' : 'bg-white hover:bg-slate-50 border border-slate-200'
      }`}
    >
      <Paperclip className="w-3 h-3" /> {attachment.filename} <Download className="w-3 h-3" />
    </a>
  );
};

export default AttachmentPreview;
